import React from "react";

/**
 * DS PlaybookBanner — figma 1640:41086 "활용백서 배너".
 *
 * bg: BG/UltraLightBlue #F5F9FF, radius 8, h 42, padding 24×6.
 * title (SemiBold 16/26 Text/Accent) · desc (Regular 14/22 Text/Tertiary)
 * · "활용백서" 밑줄 링크 (SemiBold 14/22 Text/Tertiary, padding 8)
 *
 * 시안 우측의 닫기 X 는 뺐다 (우진 결정) — 배너 전체가 열기 버튼이고
 * "활용백서" 밑줄이 그 어포던스다.
 *
 * @param {object} props
 * @param {string} props.title - 대시보드 메뉴명 (예: "등급 설정")
 * @param {string} props.desc
 * @param {() => void} props.onOpen
 */
const DSPlaybookBanner = ({ title, desc, onOpen }) => {
  return (
    <div
      className="ds-playbook-banner"
      role="button"
      tabIndex={0}
      onClick={onOpen}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onOpen && onOpen();
        }
      }}
    >
      <span className="ds-playbook-banner__title">{title}</span>
      <span className="ds-playbook-banner__desc">{desc}</span>
      <span className="ds-playbook-banner__link">활용백서</span>
    </div>
  );
};

export default React.memo(DSPlaybookBanner);
